module.exports = __webpack_public_path__ + "static/media/bell.995017a2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/bell.mp3
// module id = 35
// module chunks = 0